export default __webpack_public_path__ + "static/sensor-e2276e0b68b817903aa20dc645018cbf.svg";